import { render, staticRenderFns } from "./ShokurekishoEdit.vue?vue&type=template&id=54a681d8&scoped=true"
import script from "./ShokurekishoEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShokurekishoEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ShokurekishoEdit.vue?vue&type=style&index=0&id=54a681d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a681d8",
  null
  
)

export default component.exports